import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { Link } from 'react-router-dom';
import makePath from 'helpers/makePath';

// Style
import { withStyles } from '@material-ui/core/styles';

const styles = theme => {
  return {
    root: {
      ...theme.typography.overline,
      display: 'flex',
      color: '#7197B1',
      marginBottom: theme.spacing(1),
    },
    crumb: {},
    link: {
      textDecoration: 'none',
      cursor: 'pointer',
      color: '#7197B1',
    },
    divider: {},
  };
};

/**
 * Generates Breadcrumbs for pages using the Routes declared
 * in the Routes component.
 *
 * NOTE: @matp (thats me) is not a fan of having to import the
 * `createRoutes` file here. Similar to `withRouter` we could
 * have something like `withRoutesAndRouter` or explore a
 * `withContext` like wrapper that we can load up with things
 * such as the Router and all the available Routes.
 *
 * @export Breadcrumbs
 * @class Breadcrumbs
 * @extends {React.PureComponent}
 */
class Breadcrumbs extends React.PureComponent {
  static propTypes = {
    /**
     * An array of route names which match keys found
     * in the `createRoutes` file.
     */
    routes: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
  };
  render() {
    const { routes, classes } = this.props;

    const links = routes.map((route, index) => {
      const { name, title, params } = route;
      const isLast = routes.length - 1 === index;
      const to = makePath(name || route, params);

      return (
        <span className={classes.crumb} key={name || route}>
          <Link to={to} className={classes.link}>
            {' ' + (title || name || route) + ' '}
          </Link>
          {!isLast && <span className={classes.divider}>/&nbsp;</span>}
        </span>
      );
    });

    return <div className={classes.root}>{links}</div>;
  }
}

export default withStyles(styles)(Breadcrumbs);
